import ParticlesBg from "./components/ParticlesBg";
// import img from "./imgs/js-vector2.png";
import SocialLinks from "../../general/socialLinks/SocialLinks";
import { Zoom } from "react-awesome-reveal";
import Text from "./components/Text";

export default function Hero() {
  return (
    <section id="home" className="relative top-16 sp-calc-height">
      <ParticlesBg />

      {/*  */}
      <div className="container h-full flex items-center justify-between max-md:flex-col max-md:justify-around">
        <div className="flex flex-col gap-4 max-md:items-center max-md:text-center">
          {/*  */}
          <Text />

          {/*  */}
          <SocialLinks />
        </div>

        <Zoom>
          <img
            src={`imgs/js-vector2.png`}
            alt={`imgs/js-vector2.png`}
            className="w-[700px] max-xl:w-[500px] max-lg:w-96 max-md:w-80"
          />
        </Zoom>
      </div>
    </section>
  );
}
